module.exports = __webpack_public_path__ + "img/fangkuanshibai.b161d89e.png";